<template>
  <div class="growthfootprintassemblyadd">
    <div class="header">
      <el-button size="medium" @click="$router.go(-1)">返回</el-button>
      <el-button size="medium" type="primary" @click="addfun(1)">新增</el-button>
    </div>
    <div class="body" :style="`height: ${windowHeight - 170}px;`">
        <div class="img-box" :key="index" v-for="(item,index) in dataList">
            <img :src="item.coverLogo" alt="">
            <img :src="item.backCoverLogo" alt="">
            <div class="bottom">
                 {{item.logoCode}}
                 <i class="el-icon-edit" @click="addfun(2,item)"></i>
                 <i class="el-icon-delete" @click="delGrowthBookAssemblyLogoById(item.id)"></i>
            </div>
        </div>
          <default-page Mes="暂无组件背景" v-if="mynum==0"></default-page>
    </div>
     <el-dialog :title="formData.id?'编辑组件背景设置':'新增组件背景设置'" :close-on-press-escape='false' :close-on-click-modal='false' :visible.sync="dialogVisible" width="700px" :lock-scroll="false" :modal-append-to-body='false'>
			<el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
          <el-form-item label="组件编码" prop="logoCode">
            <el-input v-model.trim="formData.logoCode" :disabled="formData.id!=''" :maxlength="10" placeholder="请输入组件编码"></el-input>
          </el-form-item>
          <el-form-item label="封面" prop="coverLogo">
            <uploader pathPrefix="cardTemplate" :extList="['bmp', 'png', 'jpg', 'jpeg']" showResult="image" v-model="coverLogo" :openDelete="true"></uploader>
          </el-form-item>
          <el-form-item label="封底" prop="backCoverLogo">
            <uploader pathPrefix="cardTemplate" :extList="['bmp', 'png', 'jpg', 'jpeg']" showResult="image" v-model="backCoverLogo" :openDelete="true"></uploader>
          </el-form-item>
          <el-form-item label="效果图" prop="effectLogo">
            <uploader pathPrefix="cardTemplate" :extList="['bmp', 'png', 'jpg', 'jpeg']" showResult="image" v-model="effectLogo" :openDelete="true"></uploader>
          </el-form-item>
          <el-form-item label="扉页" prop="titlePageLogo">
            <uploader pathPrefix="cardTemplate" :extList="['bmp', 'png', 'jpg', 'jpeg']" showResult="image" v-model="titlePageLogo" :openDelete="true"></uploader>
          </el-form-item>
        </el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="saveModule">确 定</el-button>
			</span>
		</el-dialog>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize';
  import Uploader from "@/components/Uploader/WebUploader";
  import DefaultPage from "@/components/DefaultPage";
  import {addGrowthBookAssemblyLogo, editGrowthBookAssemblyLogo, getGrowthBookAssemblyLogoById,getGrowthBookAssemblyLogoListByAssemblyCode,delGrowthBookAssemblyLogoById} from '@/api/growthfootprint';
  export default {
    components: {Uploader,DefaultPage},
    data() {
      const validateLogo = (rule, value, callback) => {
        if (!this.backCoverLogo.length || !this.coverLogo.length|| !this.effectLogo.length|| !this.titlePageLogo.length) {
          callback(new Error('请上传所有图片'));
        } else {
          callback();
        }
      };
      return {        
        formData: {
            assemblyCode: this.$route.query.assemblyCode,
            backCoverLogo:"",//	封底图片	string	
            coverLogo:"",//	封面图片	string	
            effectLogo:"",//	效果图片	string	
            fontColor:"",//	页面字体颜色	string	
            logoCode:"",//	背景编码	string	
            logoName:"",//	背景名称	string	
            titlePageLogo:"",//	扉页图片	string
            id:""
        },
        rules: {
          backCoverLogo: [
            {required: true, validator: validateLogo}
          ],
          coverLogo: [
            {required: true, validator: validateLogo}
          ],
          effectLogo: [
            {required: true, validator: validateLogo}
          ],
          titlePageLogo: [
            {required: true, validator: validateLogo}
          ],
          logoCode: [
            { required: true, trigger: 'blur', message: '请输入组件编码' }
          ]
        },
        backCoverLogo: [],
        coverLogo: [],
        effectLogo: [],
        titlePageLogo: [],
        dialogVisible:false,
        dataList:[],
        mynum:-1
      }
    },
    mixins: [windowResize],
    created() {
        this.getGrowthBookAssemblyLogoListByAssemblyCode();
    },
    methods: {
         //获取列表
            getGrowthBookAssemblyLogoListByAssemblyCode() {
                getGrowthBookAssemblyLogoListByAssemblyCode(this.$route.query.assemblyCode)
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data;
                        this.mynum=data.data.length;
                    })
            },
            //删除
      delGrowthBookAssemblyLogoById(id){
          this.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delGrowthBookAssemblyLogoById(id).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getGrowthBookAssemblyLogoListByAssemblyCode();
                    }).catch();

                }).catch(() => {
                });
      },
      addfun(num,obj){
          if(num==1){
           this.formData.id ='';
           this.formData.logoCode =  "";            
            this.titlePageLogo = [];
            this.coverLogo =  [];
            this.effectLogo =  [];
            this.backCoverLogo =  [];
          }else{
            this.formData.id =  obj.id;
            this.formData.logoCode =  obj.logoCode;            
            this.titlePageLogo = [{fileUrl: obj.titlePageLogo}];
            this.coverLogo = [{fileUrl: obj.coverLogo}];
            this.effectLogo = [{fileUrl: obj.effectLogo}];
            this.backCoverLogo = [{fileUrl: obj.backCoverLogo}];
          }
          this.dialogVisible=true;
      },
      getGrowthBookAssemblyLogoById(id) {
        getGrowthBookAssemblyLogoById(id).then(res => res.data).then(data => {
          if (data.code === 200 && data.result) {
            this.formData.logoCode =  data.data.logoCode;            
            this.titlePageLogo = [{fileUrl: data.data.titlePageLogo}];
            this.coverLogo = [{fileUrl: data.data.coverLogo}];
            this.effectLogo = [{fileUrl: data.data.effectLogo}];
            this.backCoverLogo = [{fileUrl: data.data.backCoverLogo}];
          }
        });
      },
      saveModule() {
        this.$refs.form.validate(isValid => {
          if(isValid) {
            this.formData.titlePageLogo = this.titlePageLogo[0].fileUrl;
            this.formData.coverLogo = this.coverLogo[0].fileUrl;
            this.formData.effectLogo = this.effectLogo[0].fileUrl;
            this.formData.backCoverLogo = this.backCoverLogo[0].fileUrl;
            new Promise(resolve => {
              if(this.formData.id) {
                editGrowthBookAssemblyLogo(this.formData).then(res => res.data).then(resolve)
              } else {
                addGrowthBookAssemblyLogo(this.formData).then(res => res.data).then(resolve)
              }
            }).then(data => {
              if (data.code === 200 && data.result) {
                this.$message.success(`${this.formData.id ? '编辑' : '新增'}成功`);   
                this.dialogVisible=false;    
                this.getGrowthBookAssemblyLogoListByAssemblyCode();        
              } else {
                this.$message.error(data.msg);
              }
            })
          }
        })
      }
    }
  }
</script>

<style>
  .growthfootprintassemblyadd .upload-block-container .upload-file-item{
    width: 120px;
    height: 170px;
  }
  .growthfootprintassemblyadd .upload-block-container .upload-file-item img{
    width: 120px;
    height: 170px;
  }
</style>
<style lang="scss" scoped>
  .growthfootprintassemblyadd{
    padding: 12px;
    *{
        box-sizing: border-box;
    }
    .header {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }
    .body{
     overflow: auto;
     .img-box{         
         float: left;
         width: 243px;
         border:1px solid #efefef;
         height: 172px;
         position: relative;
         margin: 10px;
         img{
             height: 170px;
             width: 120px;
             float: left;
         }
         .bottom{
             position: absolute;
             height: 36px;
             line-height: 36px;
             padding: 0 10px;
             background: rgba($color: #000000, $alpha: 0.2);
             color: #fff;
             font-size: 14px;
             bottom:0;
             left: 0;
             width: 100%;
             i{
                float: right;
                font-size: 18px;
                color: #409EFF;
                cursor: pointer;
                line-height: 36px;
                margin-left: 10px;
             }
             .el-icon-delete{
                 color: #F56C6C;
             }
         }
     }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/growthfootprint/growthfootprintassemblyadd.vue